const breakpoints = {
  mobile: '768px',
  desktop: '1140px',
}

export default breakpoints
